/**
 * Lazy-load the AP24 web widget script only when the widget element is present on the page.
 * This avoids loading the external script on pages that don't use the widget.
 */
window.addEventListener('load', function () {
    const widgetElement = document.querySelector('ap24-webwidget');
    const scriptExists = !!document.getElementById('ap24-webwidget-script');

    // Only load script if widget exists and script hasn't been loaded yet
    if (widgetElement && !scriptExists) {
        const scriptUrl = document.body.dataset.ap24WebwidgetScriptUrl;
        if (scriptUrl) {
            const script = document.createElement('script');
            script.src = scriptUrl;
            script.id = 'ap24-webwidget-script';
            script.async = true;
            document.head.appendChild(script);
        }
    }
});
